import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function getReturnLabel(options) {
    const { baseUrl, brandId, country, email, returnId, externalOrderId, uberToken, clientId, clientSecret } = options;

    invariant(baseUrl, 'baseUrl is a required param of getReturnLabel()');
    invariant(brandId, 'brandId is a required param of getReturnLabel()');
    invariant(country, 'country is a required param of getReturnLabel()');
    invariant(externalOrderId, 'externalOrderId is a required param of getReturnLabel()');
    invariant(returnId, 'returnId is a required param of getReturnLabel()');
    invariant(clientId, 'clientId is a required param of getReturnLabel()');

    const payload = {
        email,
        externalOriginalOrderId: externalOrderId,
    };

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/return/${returnId}/label`;
    const request = new Request(url, { headers: new Headers(headers), method: 'POST', body: JSON.stringify(payload) });

    return labelRequest(authenticatedRequest(request, uberToken, clientId, clientSecret), 'getReturnLabel');
}
